import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteBusSchedule = ({ busCourseId, id }) => {
  return api.delete(`/admin/bus-courses-v2/${busCourseId}/schedules/${id}`);
};

export const useDeleteBusScheduleMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteBusSchedule,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries({
        queryKey: ["bus-schedules"],
      });
      queryClient.removeQueries({
        queryKey: ["delete-bus-schedule-simulate"],
      });
    },
    ...restConfig,
  });
};
